// src/components/Navbar/Navbar.jsx
import { useEffect, useRef, useState } from "react";
import escudo from "../../assets/theme-images/uaceuti.png";
import "./Navbar.css";

const Navbar = ({ activeSection, onChangeSection }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hideOnMobile, setHideOnMobile] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const currentY = window.scrollY;
      setScrolled(currentY > 4);

      const isMobile = window.innerWidth < 768;

      // En desktop nunca ocultamos
      if (!isMobile) {
        setHideOnMobile(false);
        lastScrollY.current = currentY;
        return;
      }

      const delta = currentY - lastScrollY.current;

      // Scroll hacia abajo (bajando más de 5px) y algo desplazado desde el top
      if (delta > 5 && currentY > 60) {
        setHideOnMobile(true);
        // cerramos el menú si estaba abierto
        setOpen(false);
        document.body.classList.remove("menu-open");
        document.body.style.overflow = "";
      }
      // Scroll hacia arriba (subiendo más de 5px)
      else if (delta < -5) {
        setHideOnMobile(false);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    // inicial
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    //{ id: "news", label: "Noticias" },
    //{ id: "watch", label: "Vídeos" },
    { id: "teams", label: "Equipo" },
    { id: "matches", label: "Partidos" },
  ];


  return (
    <header
      className={`nufc-wrapper sticky top-0 z-50 ${
        scrolled ? "is-scrolled" : ""
      } ${hideOnMobile ? "mobile-hidden" : ""}`}
    >
      {/* hairline superior */}
      <div className="top-hairline" />

      {/* fila del escudo (desktop) */}
      <div className="hidden md:block escudo-row">
        <div className="relative mx-auto max-w-7xl px-6">
          <div className="flex items-center justify-center py-6">
            <a href="/" className="escudo-badge inline-flex items-center">
              <img
                src={escudo}
                alt="U.A. Ceutí"
                className="h-12 w-12 object-contain"
                fetchpriority="high"
              />
            </a>
          </div>
        </div>
      </div>

      {/* fila compacta (mobile) */}
      <div className="md:hidden escudo-row">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
          <a href="/" className="inline-flex items-center gap-2">
            <img
              src={escudo}
              alt="U.A. Ceutí"
              className="h-9 w-9 object-contain"
            />
            <span className="font-semibold tracking-tight text-black">
              U.A. Ceutí
            </span>
          </a>
          <div className="flex items-center gap-2">
            <button
              className="icon-btn icon-btn--ring"
              aria-label="Abrir menú"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              {open ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              )}
            </button>
          </div>
        </div>

                {/* panel móvil */}
        <div className={`mobile-panel ${open ? "open" : ""}`}>
          <ul className="flex flex-col px-4 py-3">
            {links.map((l) => (
              <li key={l.id} className="mobile-item">
                <button
                  type="button"
                  className={`block w-full text-left py-2 nav-link ${
                    activeSection === l.id ? "nav-cta" : ""
                  }`}
                  onClick={() => {
                    onChangeSection(l.id);          // <- aquí cambiamos sección
                    setOpen(false);                // cerramos menú
                    document.body.classList.remove("menu-open");
                    document.body.style.overflow = "";
                  }}
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

      </div>

      {/* línea negra fina encima del menú (solo desktop) */}
      <div className="nav-blackline hidden md:block" aria-hidden="true" />

      {/* rail de navegación (desktop) */}
      <nav className="nav-rail hidden md:block">
        <ul className="mx-auto flex max-w-7xl items-center justify-center gap-10 px-6 py-3 font-semibold text-[15px] text-black">
          {links.map((l) => (
            <li key={l.id}>
              <button
                type="button"
                onClick={() => onChangeSection(l.id)}
                className={`nav-link ${activeSection === l.id ? "nav-cta" : ""}`}
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>


      {/* línea negra fina debajo del menú (solo desktop) */}
      <div className="nav-blackline hidden md:block" aria-hidden="true" />
    </header>
  );
};

export default Navbar;
